import { Availability, HomeDto, User } from '@lmc/ts-common'
import { Text } from '@lmc/ui-kit/src/general'
import { TFunction } from 'react-i18next'

export const getContractItems = (
  workProfile: User['workProfile'] | undefined,
  t: TFunction,
  home: HomeDto
) => {
  return [
    ...(workProfile?.contractType
      ? [
          {
            key: 1,
            label: <Text>{t('CONTRACT_TYPE')}</Text>,
            children: (
              <Text>
                {
                  home?.rotaSettings?.contractTypes?.find(
                    (contractType) =>
                      contractType.id === workProfile?.contractType
                  )?.name
                }
              </Text>
            ),
          },
        ]
      : []),
    ...(workProfile?.contractedHoursPerWeek
      ? [
          {
            key: 2,
            label: <Text>{t('CONTRACTED_HOURS_PER_WEEK')}</Text>,
            children: (
              <Text>{`${workProfile?.contractedHoursPerWeek} hours`}</Text>
            ),
          },
        ]
      : []),
    ...(workProfile?.contractNotes
      ? [
          {
            key: 3,
            label: <Text>{t('CONTRACT_NOTES')}</Text>,
            children: <Text>{workProfile?.contractNotes}</Text>,
          },
        ]
      : []),
  ]
}

export const getOtherItems = (
  workProfile: User['workProfile'] | undefined,
  t: TFunction
) => {
  return [
    ...(workProfile?.canDoOvertime
      ? [
          {
            key: 1,
            label: <Text>{t('OVERTIME')}</Text>,
            children: <Text>{t('WILLING_TO_WORK_OVERTIME')}</Text>,
          },
        ]
      : [
          {
            key: 1,
            label: <Text>{t('OVERTIME')}</Text>,
            children: <Text>{t('PREFERS_NOT_TO_WORK_OVERTIME')}</Text>,
          },
        ]),
    ...(workProfile?.availableTransportation?.length
      ? [
          {
            key: 2,
            label: <Text>{t('TYPE_OF_TRANSPORT')}</Text>,
            children: (
              <Text>{workProfile?.availableTransportation?.join(', ')}</Text>
            ),
          },
        ]
      : []),
  ]
}

export const defaultAvailability: Availability = {
  monday: [
    { name: 'Day', startTime: '08:00', endTime: '14:00', available: false },
    { name: 'Evening', startTime: '14:00', endTime: '20:00', available: false },
    { name: 'Night', startTime: '20:00', endTime: '08:00', available: false },
  ],
  tuesday: [
    { name: 'Day', startTime: '08:00', endTime: '14:00', available: false },
    { name: 'Evening', startTime: '14:00', endTime: '20:00', available: false },
    { name: 'Night', startTime: '20:00', endTime: '08:00', available: false },
  ],
  wednesday: [
    { name: 'Day', startTime: '08:00', endTime: '14:00', available: false },
    { name: 'Evening', startTime: '14:00', endTime: '20:00', available: false },
    { name: 'Night', startTime: '20:00', endTime: '08:00', available: false },
  ],
  thursday: [
    { name: 'Day', startTime: '08:00', endTime: '14:00', available: false },
    { name: 'Evening', startTime: '14:00', endTime: '20:00', available: false },
    { name: 'Night', startTime: '20:00', endTime: '08:00', available: false },
  ],
  friday: [
    { name: 'Day', startTime: '08:00', endTime: '14:00', available: false },
    { name: 'Evening', startTime: '14:00', endTime: '20:00', available: false },
    { name: 'Night', startTime: '20:00', endTime: '08:00', available: false },
  ],
  saturday: [
    { name: 'Day', startTime: '08:00', endTime: '14:00', available: false },
    { name: 'Evening', startTime: '14:00', endTime: '20:00', available: false },
    { name: 'Night', startTime: '20:00', endTime: '08:00', available: false },
  ],
  sunday: [
    { name: 'Day', startTime: '08:00', endTime: '14:00', available: false },
    { name: 'Evening', startTime: '14:00', endTime: '20:00', available: false },
    { name: 'Night', startTime: '20:00', endTime: '08:00', available: false },
  ],
}
